import React, { useMemo } from "react";
import { NotificationBody, NotificationButton, NotificationButtonWrapper, NotificationMessage, NotificationWrapper } from "./styles";
import { Popconfirm, Tooltip, FormInstance, Form, Input, Checkbox } from "antd";
import { PendingRequestOperation } from "../../types/LostStatuses";
import StyledModal from "../CustomModal";
import { ReasonFooterContainer } from "../../pages/ReportDetails/ReportDetailsHeader/styles";
import { StyledButton } from "../styles";

type NotificationProps = {
  message: string;
  onApprove: () => void;
  onDisapprove: (rejectReason: string) => void;
  status: PendingRequestOperation;
  form?: FormInstance;
  title?: string;
};

const Notification: React.FC<NotificationProps> = ({ message, onApprove, onDisapprove, status, form, title }) => {

  const [isDisapproveModalVisible, setIsDisapproveModalVisible] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const isDelete = useMemo(() => status === PendingRequestOperation.Delete, [status]);
  const unlinkReason = Form.useWatch(["unlinkReason"], form);

  const handleFinishDisapprove = async (values: { rejectReason: string }) => {
    setLoading(true);
    try {
      await onDisapprove(values.rejectReason);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
    setIsDisapproveModalVisible(false);
  };

  const popContent = (
    <div>
      <p>{title || ""}</p>
      {form && isDelete && (
        <Form form={form} layout="vertical">
          <Form.Item label="Reason for unlink" name="unlinkReason" rules={[{ required: true, message: "Please enter a unlink reason" }]}>
            <Input.TextArea rows={2} />
          </Form.Item>
        </Form>
      )}
    </div>
  );

  return (
    <>
      <NotificationWrapper color={isDelete ? "#fdf2f0" : "#fffbe6"} borderColor={isDelete ? "#f7cec8" : "#ffd666"}>
        <NotificationBody>
          <NotificationMessage>{message}</NotificationMessage>

          <NotificationButtonWrapper>
            <NotificationButton color={isDelete ? "#ff4d4f" : "#faad14"} variant="outline" onClick={() => setIsDisapproveModalVisible(true)}>
              Disapprove
            </NotificationButton>
            <Popconfirm
              title="Confirm Approve"
              description={isDelete ? popContent : "Are you sure you want to approve this request?"}
              onConfirm={() => onApprove()}
              okText="Yes"
              okButtonProps={{ disabled: isDelete ? !unlinkReason?.trim() : false }}
              cancelText="No"
            >
              <NotificationButton color={isDelete ? "#ff4d4f" : "#faad14"} variant="primary">
                Approve
              </NotificationButton>
            </Popconfirm>
          </NotificationButtonWrapper>
        </NotificationBody>
        {/* disapprove modal */}
        <StyledModal
          draggable={true}
          footer={
            <ReasonFooterContainer>
              <StyledButton onClick={() => setIsDisapproveModalVisible(false)} disabled={loading}>
                Cancel
              </StyledButton>
              <StyledButton type="primary" onClick={() => form?.submit()} loading={loading} disabled={loading}>
                Disapprove
              </StyledButton>
            </ReasonFooterContainer>
          }
          open={isDisapproveModalVisible}
          onCancel={() => setIsDisapproveModalVisible(false)}
          title="Are you sure you want disapprove?"
        >
          <Form form={form} onFinish={handleFinishDisapprove} autoComplete="off" layout="vertical" style={{ marginTop: "20px" }}>

            <Form.Item name="rejectReason" label="Reason" rules={[{ required: true, message: "Please enter reason" }]}>
              <Input.TextArea placeholder="Reason" name="rejectReason" />
            </Form.Item>

            <Form.Item
              name="disapprove"
              valuePropName="checked"
              rules={[
                {
                  validator(_, value) {
                    if (value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Please check the box to confirm disapprove."));
                  },
                },
              ]}
            >
              <Checkbox id="disapprove">
                I confirm that I want to disapprove
              </Checkbox>
            </Form.Item>
          </Form>
        </StyledModal>
      </NotificationWrapper>
    </>
  );
};

export default Notification;
